/* global google */
import React from 'react';
import {compose, withProps, /* withState, */ withHandlers, withStateHandlers} from "recompose";
import {withScriptjs, withGoogleMap, GoogleMap, Marker, Circle, InfoWindow} from "react-google-maps"
import confConst from '../../../../config/const';


const getAddress = (latLng, cb) => {
  const geocoder = new google.maps.Geocoder();
  geocoder.geocode({latLng}, (results, status) => {
    if (status === google.maps.GeocoderStatus.OK) {
      if (results[0]) {
        cb({
          address: results[0].formatted_address,
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng(),
        });
      } else
        console.log("No results found");
    } else
      console.log(`Geocoder failed due to:  + ${status}`);
  });
};

export default compose(
  withProps((pr) => {
    return {
      googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${confConst.MAP.KEY}&v=3.exp&libraries=geometry,drawing,places`,
      loadingElement: (
        <div
          style={{height: `100%`}}
        />),
      containerElement: (
        <div
          style={{height: `${pr.height}px`}}
        />),
      mapElement: (
        <div
          style={{height: `100%`}}
        />),
    }
  }),
  // withState('zoom', 'onZoomChange', 11),
  withStateHandlers(() => ({
    isOpen: {},
  }), {
    onCloseInfo: () => () => ({
      isOpen: {},
    }),
    onInfoOpen: () => (id) => {
      return {isOpen: {[id] : true}}
    }
  }),
  withHandlers((pr) => {
    const refs = {
      map: undefined,
    };

    return {
      onMapMounted: () => ref => {
        refs.map = ref;
        pr.mapReady(ref)
      },
      onZoomChanged: ({onZoomChange, onCloseInfo}) => () => {
        // console.log('TEST', pr)
        onCloseInfo();
        onZoomChange(refs.map, refs.map.getCenter(), refs.map.getZoom())
      },
      onDraged: ({onDragMap, onCloseInfo}) => () => {
        onCloseInfo();
        onDragMap(refs.map, refs.map.getCenter(), refs.map.getZoom())
      }
    }
  }),
  withScriptjs,
  withGoogleMap
)(props => {
    const {
      center,
      zoom,
      markers,
      radius,
      isMarkerShown,
      onCircleAddress,
      isShowAddressOnMap,
      markerAddress,
    } = props;

    return (
      <GoogleMap
        defaultZoom={+zoom}
        defaultCenter={{...center}}
        ref={(m) => {
          props.onMapMounted(m);
        }}
        onZoomChanged={props.onZoomChanged}
        onDragEnd={props.onDraged}
      >
        {
          isMarkerShown && markers.length > 0 ? markers.map((marker) => {
            // console.log(marker)
            return (
              <Marker
                key={`mrk-${marker.lat}--${marker.lng}--${marker.countId}`}
                position={{...marker}}
                defaultIcon={{url: marker.icon, scaledSize: new google.maps.Size(85, 85)}}
                onClick={(e) => {
                  getAddress(e.latLng, (address) => {
                    onCircleAddress(address)
                  });

                }}
                onFocus={()=>{}}
                onMouseOver={()=>props.onInfoOpen(marker.countId)}
              >
                {
                  props.isOpen && props.isOpen[marker.countId] ?
                    <InfoWindow onCloseClick={()=>props.onCloseInfo}>
                      <div>
                        <h3>{marker.name} <span>{marker.countId}</span></h3>
                        <p>{marker.address}</p>
                      </div>
                    </InfoWindow> : null
                }
              </Marker>
            )
          }) : null
        }
        {
          isShowAddressOnMap &&
          <Marker
            key={`mrk-address-${markerAddress.lat}--${markerAddress.lng}`}
            position={{...markerAddress}}
          />
        }
        {
          radius &&
          <Circle
            radius={radius * 1000}
            center={{...center}}
            options={{
              strokeColor: '#005fea',
              strokeOpacity: 0.65,
              strokeWeight: 1,
              fillColor: '#408bfa',
              fillOpacity: 0.25,
            }}
            onClick={(e) => {
              getAddress(e.latLng, (address) => {
                onCircleAddress(address)
              })
            }}
            visible
          />
        }
      </GoogleMap>
    )
  }
);


// WEBPACK FOOTER //
// ./src/app/containers/Cart/components/Map/Component.js